interface Props {
  isFilled?: boolean;
  onClick?: () => void;
}

const StarIcon = ({ isFilled, onClick }: Props) => {
  return (
    <svg onClick={onClick} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      {isFilled ? (
        <path
          d="M10.8509 0.555469L13.1571 5.22891C13.3025 5.52187 13.5814 5.72578 13.9071 5.77266L19.0634 6.52266C19.879 6.64219 20.2048 7.64531 19.6142 8.21953L15.8829 11.857C15.6486 12.0867 15.5407 12.4148 15.597 12.7383L16.4782 17.8734C16.6165 18.6867 15.7634 19.3055 15.0345 18.9234L10.422 16.4977C10.1314 16.3453 9.78449 16.3453 9.4962 16.4977L4.88136 18.9234C4.15011 19.3078 3.29698 18.6867 3.43761 17.8734L4.31886 12.7383C4.37511 12.4148 4.26729 12.0867 4.03292 11.857L0.301668 8.21953C-0.288957 7.64297 0.036824 6.63984 0.852449 6.52266L6.0087 5.77266C6.33214 5.72578 6.61339 5.52187 6.7587 5.22891L9.06495 0.555469C9.43058 -0.185156 10.4853 -0.185156 10.8509 0.555469Z"
          fill="#FFB800"
        />
      ) : (
        <path
          d="M11.514 0.555469L13.8202 5.22891C13.9655 5.52187 14.2444 5.72578 14.5702 5.77266L19.7265 6.52266C20.5421 6.64219 20.8679 7.64531 20.2773 8.21953L16.546 11.857C16.3116 12.0867 16.2038 12.4148 16.2601 12.7383L17.1413 17.8734C17.2796 18.6867 16.4265 19.3055 15.6976 18.9234L11.0851 16.4977C10.7944 16.3453 10.4476 16.3453 10.1593 16.4977L5.54444 18.9234C4.81319 19.3078 3.96007 18.6867 4.10069 17.8734L4.98194 12.7383C5.03819 12.4148 4.93038 12.0867 4.69601 11.857L0.964754 8.21953C0.374128 7.64297 0.69991 6.63984 1.51554 6.52266L6.67179 5.77266C6.99523 5.72578 7.27648 5.52187 7.42179 5.22891L9.72804 0.555469C10.0937 -0.185156 11.1484 -0.185156 11.514 0.555469Z"
          fill="#363636"
        />
      )}
    </svg>
  );
};

export default StarIcon;
